import React, { useState, Component } from 'react';
import { Star, Truck, Check, ChevronRight, Leaf } from 'lucide-react';

// --- Internal Component: SubscriptionCard ---
const SubscriptionCard = ({
  selected,
  onSelect,
  title,
  discountPercent,
  benefits
}) => {
  return <div onClick={onSelect} className={`relative cursor-pointer rounded-xl border-2 transition-all duration-300 overflow-hidden ${selected ? 'border-[#496f58] bg-[#fdfdfd] shadow-md' : 'border-gray-200 bg-white hover:border-[#aebfba]'}`} data-id="element-319">
      {selected && <div className="absolute top-0 right-0 bg-[#496f58] text-white text-[10px] font-bold px-2 py-1 rounded-bl-lg z-10" data-id="element-320">
          SELECTED
        </div>}

      <div className="p-4 lg:p-5" data-id="element-321">
        <div className="flex justify-between items-center mb-2" data-id="element-322">
          <div className="flex items-center gap-3" data-id="element-323">
            <div className={`w-5 h-5 rounded-full border flex items-center justify-center transition-colors ${selected ? 'border-[#496f58] bg-[#496f58]' : 'border-gray-300'}`} data-id="element-324">
              {selected && <div className="w-2 h-2 bg-white rounded-full" data-id="element-325" />}
            </div>
            <div data-id="element-326">
              <h3 className={`font-serif text-lg font-bold ${selected ? 'text-[#2d4a3a]' : 'text-gray-700'}`} data-id="element-327">
                {title}
              </h3>
            </div>
          </div>
          {discountPercent && <span className="bg-[#e8f5e9] text-[#2d4a3a] text-xs font-bold px-2 py-1 rounded-md" data-id="element-328">
              SAVE {discountPercent}
            </span>}
        </div>

        {benefits.length > 0 && <div className="ml-8 mt-2 space-y-1.5" data-id="element-329">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-2 text-xs lg:text-sm text-gray-600" data-id="element-330">
                <Check className="w-3.5 h-3.5 text-[#496f58] mt-0.5 shrink-0" data-id="element-331" />
                <span data-id="element-332">{benefit}</span>
              </div>)}
          </div>}
      </div>
    </div>;
};
export function ProductDetails() {
  const [purchaseType, setPurchaseType] = useState('subscription');
  const [quantity, setQuantity] = useState(1);
  const handleStartNow = () => {
    if (purchaseType === 'subscription') {
      // Subscription: /cart/add with selling_plan and quantity
      const url = `https://faithandfig.com/cart/add?id=43794827771955&quantity=${quantity}&selling_plan=2143191091&return_to=%2Fcheckout`;
      window.location.href = url;
    } else {
      // One-time: /cart/variant:quantity?discount=...
      const url = `https://faithandfig.com/cart/43794827771955:${quantity}?discount=ExtendedBlackFriday20`;
      window.location.href = url;
    }
  };
  return <div className="w-full" data-id="element-333">

      {/* Product Title */}
      <div data-id="element-334">
        <h1 className="font-serif text-3xl lg:text-5xl font-bold text-[#2d4a3a] mb-3" data-id="element-335">
          4:14 Saffron
        </h1>

        <div className="inline-block border-2 border-[#496f58] text-[#496f58] text-xs font-bold px-3 py-1.5 rounded-full mb-4" data-id="element-336">
          Biblical Botanicals for the Overwhelmed Mind
        </div>

        {/* Reviews */}
        <div className="flex flex-wrap items-center gap-2 mb-4" data-id="element-337">
          <div className="flex items-center gap-1" data-id="element-338">
            <span className="font-bold text-gray-900 text-sm" data-id="element-339">Excellent</span>
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#00b67a] text-[#00b67a]" data-id="element-340" />)}
          </div>
          <div className="text-xs text-gray-600" data-id="element-341">
            <span className="font-semibold" data-id="element-342">4.9/5 on Trustpilot</span>
          </div>
        </div>

        {/* Description */}
        <p className="text-gray-700 leading-relaxed text-sm lg:text-base mb-6" data-id="element-343">
          Mute the mental noise. This clinically-studied saffron formula
          supports your brain's calm-focus-regulate cycle so you can be present
          with your kids, focused in prayer, and steady when life gets loud.
        </p>
      </div>

      {/* Price & Sale */}
      <div className="mb-2" data-id="element-344">
        <div className="flex items-baseline gap-1 mb-3 pl-1" data-id="element-345">
          <span className="font-serif text-3xl font-bold text-[#2d4a3a]" data-id="element-346">
          $
          </span>
          <span className="font-serif text-4xl font-bold text-[#2d4a3a]" data-id="element-347">
          49.99
          </span>
        </div>

        <div className="flex items-center gap-3 w-full mb-2" data-id="element-348">
          <div className="h-px bg-[#496f58]/30 flex-1" data-id="element-349" />
          <span className="font-serif text-[#496f58] font-bold text-xs tracking-widest uppercase px-1 whitespace-nowrap" data-id="element-350">
            Extended Black Friday Sale
          </span>
          <div className="h-px bg-[#496f58]/30 flex-1" data-id="element-351" />
        </div>
      </div>

      {/* Subscription Container */}
      <div className="space-y-3" data-id="element-352">

        {/* SUBSCRIPTION OPTION */}
        <SubscriptionCard selected={purchaseType === 'subscription'} onSelect={() => setPurchaseType('subscription')} title="Subscribe & Save" discountPercent="30%" benefits={['Feel calmer within 2 weeks', '30% off your first month', '15% off every month after', 'Pause or cancel anytime']} data-id="element-353" />

        {/* Quantity selector ONLY when subscription is selected */}
        {purchaseType === 'subscription' && <div className="mt-2 flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg mx-1" data-id="element-354">
            <span className="text-sm font-semibold text-[#2d4a3a]" data-id="element-355">
              Select Quantity
            </span>

            <div className="flex items-center gap-2" data-id="element-356">
              <button onClick={() => setQuantity(prev => Math.max(1, prev - 1))} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-100" data-id="element-357">
                –
              </button>

              <span className="w-8 text-center font-serif text-lg text-[#2d4a3a]" data-id="element-358">
                {quantity}
              </span>

              <button onClick={() => setQuantity(prev => Math.min(12, prev + 1))} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-100" data-id="element-359">
                +
              </button>
            </div>
          </div>}

        {/* Ships every 30 days */}
        {purchaseType === 'subscription' && <div className="flex items-center gap-3 px-4 py-3 bg-[#f4f7f5] rounded-lg border border-[#e0e9e5] mx-1 animate-in fade-in slide-in-from-top-1 duration-300" data-id="element-360">
            <Leaf className="w-4 h-4 text-[#496f58]" data-id="element-361" />
            <div className="text-xs font-semibold text-[#496f58] uppercase tracking-wide" data-id="element-362">
              Delivery Every 30 Days
            </div>
          </div>}

        {/* ONE-TIME OPTION */}
        <SubscriptionCard selected={purchaseType === 'onetime'} onSelect={() => setPurchaseType('onetime')} title="Try Today & Save" discountPercent="20%" benefits={[]} data-id="element-363" />
      </div>

      {/* Quantity selector ONLY when one-time is selected */}
      {purchaseType === 'onetime' && <div className="mt-3 flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg" data-id="element-364">
          <span className="text-sm font-semibold text-[#2d4a3a]" data-id="element-365">
            Select Quantity
          </span>

          <div className="flex items-center gap-2" data-id="element-366">
            <button onClick={() => setQuantity(prev => Math.max(1, prev - 1))} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-100" data-id="element-367">
              –
            </button>

            <span className="w-8 text-center font-serif text-lg text-[#2d4a3a]" data-id="element-368">
              {quantity}
            </span>

            <button onClick={() => setQuantity(prev => Math.min(12, prev + 1))} className="w-8 h-8 flex items-center justify-center border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-100" data-id="element-369">
              +
            </button>
          </div>
        </div>}

      {/* Add to Cart Button */}
      <button type="button" onClick={handleStartNow} className="w-full mt-6 bg-[#496f58] hover:bg-[#3d5a47] text-white font-bold text-lg py-4 rounded-xl transition-all shadow-lg hover:shadow-[#496f58]/20 flex items-center justify-center gap-2 group" data-id="element-370">
        <span data-id="element-371">Start Now</span>
        <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-372" />
      </button>

      {/* Shipping */}
      <div className="flex flex-col items-center gap-3 text-sm pt-4" data-id="element-373">
        <div className="flex items-center gap-2 text-gray-600 bg-gray-50 px-3 py-1.5 rounded-full border border-gray-100" data-id="element-374">
          <Truck className="w-4 h-4 text-[#496f58]" data-id="element-375" />
          <span className="font-medium text-xs" data-id="element-376">F&F Free Shipping Forever</span>
        </div>
      </div>
    </div>;
}